<template>
  <div
    v-editable="blok"
    class="CustomerServiceBlock layout-container"
    :class="desktopWidth('full')"
  >
    <div
      v-if="blok.headingTitle || blok.headingButtonText"
      class="flex flex-row flex-wrap justify-between items-center gap-8 mb-16"
      :class="{'flex-col text-center' : blok.headingAlign === 'center'}"
    >
      <div class="type-headline-lg desk:type-headline-2xl"> {{ blok.headingTitle }}</div>

      <Nuxt-link
        :to="$sbLinkFix(blok.headingButtonLink)"
        :target="$sbLinkTarget(blok.headingButtonLink)"
      >
        <div
          v-if="blok.headingButtonText"
          class="btn btn--primary"
          :class="{
            'btn--secondary': blok.headingButtonStyle === 'secondary',
            'btn--ghost': blok.headingButtonStyle === 'ghost',
            'btn--text': blok.headingButtonStyle === 'plain',
          }"
        >
          {{ blok.headingButtonText }}
        </div>
      </Nuxt-link>
    </div>

    <div
      class="grid gap-12"
      :class="gridColsClass"
    >
      <component
        :is="box.component"
        v-for="box in blok.boxes"
        :key="box._uid"
        :blok="box"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { StoryBlokPropBase, StoryBlokLink } from '~/constants/types/storyblok';

import useDesktopWidth from '~/composeables/useDesktopWidth';

type Props = StoryBlokPropBase & {
  title: string;
  text: string;
  boxes: StoryBlokPropBase[];
  // Heading fields
  headingTitle: string;
  headingButtonText: string;
  headingButtonLink: StoryBlokLink;
  headingButtonStyle: 'primary' | 'secondary' | 'ghost' | 'plain';
  headingAlign: 'left' | 'center';
}

const props = defineProps<{
  blok: Props,
}>();

const gridColsClass = computed(() => {
  const numBoxes = props.blok.boxes.length;
  // Set the class based on the number of items
  if (numBoxes === 5) {
    return 'grid-cols-2 desk:grid-cols-5';
  } else {
    return 'grid-cols-2 desk:grid-cols-4';
  }
});

const { desktopWidth } = useDesktopWidth(props);

</script>
